import script from "./LoginApp.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginApp.vue?vue&type=script&setup=true&lang=js"

import "./LoginApp.vue?vue&type=style&index=0&id=3f9f8552&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9f8552"]])

export default __exports__